import { __read } from "tslib";
import * as u from '@virtuoso.dev/urx';
import { domIOSystem } from './domIOSystem';
import { totalListHeightSystem } from './totalListHeightSystem';
export var alignToBottomSystem = u.system(function (_a) {
    var _b = __read(_a, 2), viewportHeight = _b[0].viewportHeight, totalListHeight = _b[1].totalListHeight;
    var alignToBottom = u.statefulStream(false);
    var paddingTopAddition = u.statefulStreamFromEmitter(u.pipe(u.combineLatest(alignToBottom, viewportHeight, totalListHeight), u.filter(function (_a) {
        var _b = __read(_a, 1), enabled = _b[0];
        return enabled;
    }), u.map(function (_a) {
        var _b = __read(_a, 3), viewportHeight = _b[1], totalListHeight = _b[2];
        return Math.max(0, viewportHeight - totalListHeight);
    }), u.distinctUntilChanged()), 0);
    return { alignToBottom: alignToBottom, paddingTopAddition: paddingTopAddition };
}, u.tup(domIOSystem, totalListHeightSystem), { singleton: true });
